<template>
	<Alert ref="alert">
		<template #alerts="{ alerts }">
			<div class="alert-container">
				<AlertList :alerts="alerts" />
			</div>
		</template>
	</Alert>
</template>

<script>
import Alert, { alertTypes } from './Alert'
import AlertList from './AlertList'

const $alert = Object.values(alertTypes).reduce((acc, type) => {
	acc[type] = (...args) => window.prontoAlert[type](...args)
	return acc
}, {})

export const AlertPlugin = {
	install: function (app) {
		Object.assign(app.config.globalProperties, { $alert })
	},
}

export function useAlert() {
	return $alert
}

export default {
	name: 'GlobalAlerts',
	components: { Alert, AlertList },
	beforeCreate() {
		const alert = Object.values(alertTypes).reduce((acc, type) => {
			acc[type] = (...args) => this.$refs.alert.alertMethods[type](...args)
			return acc
		}, {})
		window.prontoAlert = alert
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.alert-container {
	position: fixed;
	bottom: 16px;
	right: 16px;
	display: flex;
	justify-content: flex-end;
	@include max-z(1);
}
</style>
